<template>
    <default-modal
        :show="showModal"
        :height="0"
        :closeOnClickModal="false"
    >
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            class="modal-confirm-channel"
        >
            <div class="flex-basis-10">
                <el-form-item class="gcmcn-form-input" prop="profiles">
                    <div class="gcmcn-form-label profiles-input-spacing">SELECT A PROFILE FOR TAKER {{taker.name}}</div>
                    <el-select
                        v-model="form.profile"
                        placeholder="Select a profile for this taker"
                        class="gcmcn-form-label"
                        value-key="uid"
                    >
                        <el-option
                            v-for="profile in currentChannelAvailableProfiles"
                            :key="profile.uid"
                            :label="profile.display_name"
                            :value="profile"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
        </el-form>
        <div class="modal-action-button-container">
            <el-button
                class="cancel-btn"
                profiles="text"
                small
                :loading="loading"
                @click="closeModal"
            >Cancel</el-button>
            <el-button
                class="gcmcn-primary-btn small validate-btn cancel-btn"
                :loading="loading"
                @click="confirmAddedRights"
            >Validate</el-button>
        </div>
    </default-modal>

</template>

<script>
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
export default {

    components: {
        DefaultModal,
        LoadingTemplate,
    },

    props: {
        filteredBlankingProfile: {
            type: Array,
            required: true,
        },
        taker: {
            type: Object,
            required: true,
        },
        broadcastRight: {
            type: Array,
            required: true,
        },
    },

    data (){
        return {
            showModal: false,
            loading: false,
            form: {
                profile: {},
            },
            channel: null,
            blankingProfile: null,
        };
    },

    computed: {
        rules (){
            let rules = {
                profile: [{required: true}],
            };

            return rules;
        },
        currentChannelAvailableProfiles(){
            let reFilteredProfiles = this.filteredBlankingProfile.filter(profile => profile.aws_region_uid === this.taker.aws_region_uid);
            return reFilteredProfiles;
        },
    },

    mounted (){
    },

    methods: {
        open (channel, taker){
            this.showModal = true;
            this.$set(this, 'channel', channel);
            this.$set(this, 'taker', taker);
        },
        closeModal (){
            this.showModal = false;
            this.$emit('create-rights-without-creating-profile');
        },
        confirmAddedRights (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.$emit('add-taker-profile', this.form.profile);
                    this.showModal = false;
                }
            });
        },
    },
};
</script>

<style lang="scss">
.modal-confirm-channel{
    .el-input:not(.hours):not(.minutes):not(.seconds):not(.digital-clock){
        width: 100%;
    }
    .el-alert{
        .el-form-item__error{
            color: #ff1100;
        }
    }
    .options-profiles {
        padding-bottom: 0.5em;;
    }
}
.profiles-input-spacing{
    padding-bottom: 0.5em;
}
.el-button .delete-event-cancel-btn .el-button--default{
    padding: 0;
}
.cancel-btn{
    padding: 0.3em;
    background-color: white;
    color: #00A3FF;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Channels/modal-add-profile-rights.vue